module.exports = {
  progress: {
    total: 100,
    value: 20,
    type: 'line',
    steps: [],
    vertical: false,
    keep: false,
    status: 0,
    hideSteps: false,
    clip: false,
  },
};
